import { API } from 'aws-amplify';
import { USER_API_GATEWAY_ENDPOINT_NAME } from '../../../aws-exports';

// ── Enrollment APIs ──────────────────────────────────────────────────────────

export async function createEnrollment(data) {
  return API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/enrollment', { body: data });
}

export async function getEnrollments({ page = 1, limit = 20 } = {}) {
  return API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment?page=${page}&limit=${limit}`);
}

export async function getEnrollment(id) {
  return API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`);
}

export async function updateEnrollment(id, data) {
  return API.put(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`, { body: data });
}

export async function deleteEnrollment(id) {
  return API.del(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`);
}

export const getEnrollmentConstants = async () =>
  API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/payment/constant');

export const createEnrollmentConstant = async (body) =>
  API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/payment/constant', { body });


export async function removeStudentPhone({ userId }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/removePhone',
    { body: { userId } }
  );
  return response;
}

export async function inviteForDemoClass(studentId) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/user-demo-class/register',
    {
      body: {
        userId: studentId,
      },
    }
  );
  return response;
}
